import { useEffect } from "react"
import { JugglingScreen } from "@motleyhand/design"
import { windowMessageType } from "@/auth"
import { invariant } from "@/utils"

type Props = {
  result: "success" | "error" | "cancelled"
  refreshToken?: string
  error?: string
}

export default function OAuthResult({ result, refreshToken, error }: Props) {
  useEffect(() => {
    const opener = window.opener as WindowProxy | undefined
    invariant(opener)

    opener.postMessage({
      type: windowMessageType,
      result,
      refreshToken,
      error,
    })

    window.close()
  }, [result, refreshToken, error])

  return <JugglingScreen />
}
